import * as institutionsActions from './institutionsActions';
import institutionsReducer from './institutionsReducer';
import institutionsSagas from './institutionsSagas';
import * as institutionsSelectors from './institutionsSelectors';
import * as institutionsTransformers from './institutionsTransformers';
import * as institutionsTypes from './institutionsTypes';
import * as institutionsUtils from './institutionsUtils';

const { INSTITUTIONS_REDUCER_KEY } = institutionsTypes;

export {
  INSTITUTIONS_REDUCER_KEY,
  institutionsActions,
  institutionsReducer,
  institutionsSagas,
  institutionsSelectors,
  institutionsTransformers,
  institutionsTypes,
  institutionsUtils,
};
